import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import { useAppProvider } from "../AppContext";
import { TokenItem } from "../api";
import { unScaleByDecimals } from "../utils";

interface Cat20ListProps {
  items: TokenItem[];
  swap: (item: TokenItem) => void;
}

export default function Cat20List(props: Cat20ListProps) {
  const { connected } = useAppProvider();

  const items = props.items;
  // const [_ftItems, setFtItems] = React.useState<TokenItem[]>([]);

  // React.useEffect(() => {
  //   if (connected() && connectedAccount) {
  //     getTokenItems(network, connectedAccount.payment.address, true).then((items) => {
  //       setFtItems(items);
  //     })
  //     .catch((e) => {
  //       console.error("getTokenItems error", e);
  //     });
  //   }
  // }, [connected, connectedAccount, network]);

  const swapCoin = async (tokenItem: TokenItem) => {
    console.log("swapCoin:", tokenItem);
    props.swap(tokenItem);
  };

  const allItem = items.map((item) => {
    return (
      <ListItem key={item.tokenId}>
        <ListItemText
          sx={{ width: 100 }}
          primary={item.symbol}
          secondary={
            item.tokenId.substring(0, 4) +
            "..." +
            item.tokenId.substring(item.tokenId.length - 8)
          }
          primaryTypographyProps={{
            sx: {
              width: 90,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          secondaryTypographyProps={{ title: item.tokenId }}
        />
        <ListItemText
          sx={{ width: 160 }}
          primary={`v1 balance: ${unScaleByDecimals(
            item.confirmed,
            item.metadata.decimals
          )}`}
          primaryTypographyProps={{
            sx: {
              width: 150,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          secondary={`v2 balance: ${unScaleByDecimals(
            item.token2Confirmed,
            item.metadata.decimals
          )}`}
          secondaryTypographyProps={{
            sx: {
              width: 150,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
        <Button
          variant="outlined"
          onClick={() => {
            swapCoin(item);
          }}
        >
          upgrade
        </Button>
      </ListItem>
    );
  });

  // if(_ftItems.length > 0) {
  //   allItem.push(
  //     <ListItem key="cat20NonUpgradeableItem" sx={{ padding: 0 }}>
  //       <Cat20NonUpgradeableItem tokens={_ftItems}/>
  //     </ListItem>
  //   );
  // }

  return (
    <List sx={{ width: "100%", maxWidth: 460, bgcolor: "background.paper" }}>
      {connected() ? allItem : <></>}
    </List>
  );
}
